import { authHeader, handleResponse } from '../helpers';
const BASE_URL = process.env.REACT_APP_API_URL;
export const teamService = {
    getAllTeams,
    updateColour,
    getCalendlyMap,
    saveCalendlyMap
}

function getCalendlyMap() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/calendly/map`, requestOptions)
}

function saveCalendlyMap(data) {
    // Transform the data to match backend struct expectations
    const payload = {
        calendly_reference: data.CalendlyReference,
        pipedrive_id: parseInt(data.PipedriveID),
        email: data.Email
    };

    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    };

    return fetch(BASE_URL + `/calendly/map`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function updateColour(id, colour) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    colour = colour.replace("#", "");

    return fetch(BASE_URL + `/user/color/` + id + `/` + colour, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAllTeams() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(BASE_URL + `/teams/all`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}